import React, { useState, useEffect } from 'react';
import { FormattedMessage, useIntl } from '../../../util/reactIntl';
import css from './CartModalItem.module.css';

const QuantityController = ({ quantity, maxQuantity, form, fieldName = 'quantity', disabled }) => {
  const intl = useIntl();
  const [displayValue, setDisplayValue] = useState(String(quantity));
  const [isFocused, setIsFocused] = useState(false);

  useEffect(() => {
    if (!isFocused) {
      setDisplayValue(String(quantity));
    }
  }, [quantity, isFocused]);

  const handleButtonChange = (change) => {
    const newQuantity = Math.max(1, Math.min(quantity + change, maxQuantity));
    form.change(fieldName, newQuantity);
  };

  const handleInputChange = (e) => {
    const value = e.target.value;
    if (value === '') {
      setDisplayValue('');
      return;
    }

    const numValue = parseInt(value, 10);
    if (!isNaN(numValue) && numValue >= 1 && numValue <= maxQuantity) {
      setDisplayValue(value);
      form.change(fieldName, numValue);
    } else if (numValue > maxQuantity) {
      setDisplayValue(String(maxQuantity));
      form.change(fieldName, maxQuantity);
    }
  };

  const handleBlur = () => {
    setIsFocused(false);
    if (displayValue === '' || parseInt(displayValue, 10) < 1) {
      setDisplayValue('1');
      form.change(fieldName, 1);
    }
  };

  return (
    <div className={css.quantityController}>
      {/* <label className={css.quantityLabel}>
        <FormattedMessage id="CartModal.quantity" />
      </label> */}
      <div className={css.quantityControls}>
        <button
          type="button"
          className={css.quantityButton}
          onClick={() => handleButtonChange(-1)}
          disabled={disabled || quantity <= 1}
          aria-label={intl.formatMessage({ id: 'CartModal.decreaseQuantity' })}
        >
          <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M3.33398 7.33325V8.66659H12.6673V7.33325H3.33398Z" fill="#A4A7AE" />
          </svg>

        </button>
        <input
          type="number"
          className={css.quantityInput}
          value={displayValue}
          onChange={handleInputChange}
          onFocus={() => setIsFocused(true)}
          onBlur={handleBlur}
          min="1"
          max={maxQuantity}
          disabled={disabled}
        />
        <button
          type="button"
          className={css.quantityButton}
          onClick={() => handleButtonChange(1)}
          disabled={disabled || quantity >= maxQuantity}
          aria-label={intl.formatMessage({ id: 'CartModal.increaseQuantity' })}
        >
          <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M7.33398 7.33325V3.33325H8.66732V7.33325H12.6673V8.66659H8.66732V12.6666H7.33398V8.66659H3.33398V7.33325H7.33398Z" fill="#A4A7AE" />
          </svg>

        </button>
      </div>
    </div>
  );
};

export default QuantityController;

